/* eslint-disable */
import {
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCEED,
    GET_USER_DATA_FAILED
} from '../../../constants/actionTypes';//'../../const'

const initState = {
    loading: false,
    type: '',
    payload: ''
};

export default function (state = initState, action) {
    switch (action.type) {
        case GET_USER_DATA_STARTED:
            return {
                loading: true,
                type: GET_USER_DATA_STARTED
            };
        case GET_USER_DATA_SUCCEED:
            return {
                ...state,
                loading: false,
                type: GET_USER_DATA_SUCCEED,
                payload: action.payload.data.data
            };
        case GET_USER_DATA_FAILED:
            return {
                ...state,
                loading: false,
                type: GET_USER_DATA_FAILED,
                payload: action.payload
            };
        default:
            return state;
    }
}